exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.cont[data-v-028b1028] {\n  flex: 0 1 0;\n  transition: .3s cubic-bezier(.25,.8,.5,1);\n  background: white;\n  height: 0;\n  z-index: 1;\n}\n.expand[data-v-028b1028] {\n  height: 350px;\n  flex: 0 1 350px;\n}\n", ""]);
